module.exports = __webpack_public_path__ + "img/icon-hailiang-logo.d3b780b2.png";